const SCREEN_XML_TEMPLATE: string = `<screen>
	<view extends="lv_obj">
		<!-- Add your code here -->
	</view>
</screen>
`;

export default SCREEN_XML_TEMPLATE;
